import React from 'react';
import { useStacklineTheme, StacklineColor, hexToRgba } from '@stackline/ui';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

export interface StatusPillProps {
  children: string;
  color: StacklineColor;
  backgroundColor: StacklineColor;
  opacity?: number;
}

/**
 * A pill for use in the table status.
 * This pill will be placed on the table status
 */
const StatusPill = ({ children, color, backgroundColor, opacity = 0.2 }: StatusPillProps) => {
  const theme = useStacklineTheme();

  return (
    <div
      style={{
        backgroundColor: hexToRgba(theme.colors[backgroundColor], opacity),
        borderRadius: '12px',
        padding: '3px 20px',
        display: 'inline-flex'
      }}
    >
      <Text variant="subtitle2" lineHeight="1.5" color={color} sx={{ fontSize: 12 }}>
        {children}
      </Text>
    </div>
  );
};

export default StatusPill;
